import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10 5h6m-6 10h6m-6-5h6M4 12.75l.829 1.015c.26.318.793.312 1.043-.012L8 11M4 7.75l.829 1.015c.26.318.793.312 1.043-.012L8 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);